"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUpdateMopInputAccountTypeMap = exports.getMopInputAccountTypeMap = void 0;
exports.getMopInputAccountTypeMap = {
    'credit card': 'CREDIT_CARD_TOKEN',
    paypal: 'PAYPAL_TOKEN',
    yiftee: 'GIFT_CODE',
    venmo: 'VENMO',
    upi: 'UPI',
    GOOGLE_PAY: 'GOOGLE_PAY',
};
exports.createUpdateMopInputAccountTypeMap = {
    'credit card': 'CREDIT_CARD_TOKEN',
    'paypal token': 'PAYPAL_TOKEN',
    'apple pay': 'APPLE_PAY',
    upi: 'UPI',
    venmo: 'VENMO',
    GOOGLE_PAY: 'GOOGLE_PAY',
    PLACEHOLDER: 'PLACEHOLDER',
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/methodOfPaymentAPI/bff/interfaces.js
// module id = 3389
// module chunks = 11